// ── NAV SCROLL EFFECT ───────────────────────────────────
const nav = document.getElementById('SiteNav');
if (nav) {
  const onScroll = () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// ── HAMBURGER / MOBILE MENU ─────────────────────────────
const hamburger = document.querySelector('.hamburger');
const mobileMenu = document.getElementById('MobileMenu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
    hamburger.setAttribute('aria-expanded', String(!isOpen));
    mobileMenu.setAttribute('aria-hidden', String(isOpen));
  });
}

// ── SMOOTH SCROLL FOR NAV LINKS ─────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', e => {
    const target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      const y = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (mobileMenu) {
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }
    }
  });
});

// ── NEWSLETTER MODAL ────────────────────────────────────
const modal = document.getElementById('NewsletterModal');
const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
const modalClose = document.querySelector('[data-modal-close]');

function openModal() {
  if (modal) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('input')?.focus();
  }
}
function closeModal() {
  if (modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }
}

modalTriggers.forEach(btn => btn.addEventListener('click', openModal));
if (modalClose) modalClose.addEventListener('click', closeModal);
if (modal) {
  modal.addEventListener('click', e => {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeModal();
  });
}

// ── SMOOTH SECTION REVEAL ───────────────────────────────
if ('IntersectionObserver' in window) {
  const sections = document.querySelectorAll('.section, .section-alt-inner');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  sections.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    observer.observe(el);
  });
}
// ── OUTBOUND LINK TRACKING ──────────────────────────────
(function() {
  if (!window.FOP_TRACK) return;
  document.body.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;
    var href = link.href || '';
    if (!href) return;
    if (href.indexOf(window.location.hostname) !== -1) return;
    if (href.charAt(0) === '#') return;
    if (!/^https?:|^mailto:/i.test(href)) return;

    var eventId = window.FOP_TRACK.cid();
    var category = 'other';
    var metaEvent = 'OutboundClick';
    var useStandard = false;

    if (href.indexOf('absolutemerch.store') !== -1) {
      category = 'merch'; metaEvent = 'InitiateCheckout'; useStandard = true;
    } else if (/spotify\.com|music\.apple\.com|tidal\.com|deezer\.com|soundcloud\.com/.test(href)) {
      category = 'music'; metaEvent = 'ClickedMusic';
    } else if (/youtube\.com\/watch|youtu\.be/.test(href)) {
      category = 'video'; metaEvent = 'ClickedVideo';
    } else if (/instagram\.com|tiktok\.com|x\.com|twitter\.com|facebook\.com/.test(href)) {
      category = 'social'; metaEvent = 'ClickedSocial';
    } else if (/^mailto:|forms\.gle|mailchi\.mp|substack\.com/.test(href)) {
      category = 'newsletter'; metaEvent = 'Lead'; useStandard = true;
    }

    if (typeof fbq === 'function') {
      if (useStandard) {
        fbq('track', metaEvent, {}, { eventID: eventId });
      } else {
        fbq('trackCustom', metaEvent, { click_url: href, click_category: category }, { eventID: eventId });
      }
    }
    window.FOP_TRACK.send(metaEvent, { event_id: eventId, click_url: href, click_category: category });
  }, true);
})();

// ── NEWSLETTER FORM SUBMIT ──────────────────────────────
(function() {
  if (!window.FOP_TRACK) return;
  var form = document.getElementById('newsletter-form');
  if (!form) return;
  form.addEventListener('submit', function() {
    var eventId = window.FOP_TRACK.cid();
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', {}, { eventID: eventId });
    }
    window.FOP_TRACK.send('Lead', { event_id: eventId, lead_source: 'newsletter_modal' });
  });
})();